import type { CSSProperties } from "react";

/** 空间页、独立站壳、产品页容器共用的浅灰衬底 */
const SHELL_GRAY = "#fff7fd";

/**
 * 全站各页面根容器背景色，修改此处即可统一调整。
 */
export const sitePageBackground = {
  /** 平台首页首屏底色 */
  home: "#000000",
  /** 陈列场馆 / 大厅 */
  lobby: "#f0f0f0",
  /** 空间页（含产品区外层） */
  space: SHELL_GRAY,
  /** 独立站主壳 */
  standaloneShell: SHELL_GRAY,
  /** 产品页容器/衬底（跟进池 backdrop、情报 sticky 区等） */
  product: SHELL_GRAY,
} as const;

/** 顶栏导航右侧用户头像边长（px） */
export const siteNavUserAvatarSize = 32;

export type SitePageBackgroundKey = keyof typeof sitePageBackground;

/** 普通页面根容器：直接设 background */
export function sitePageBackgroundStyle(
  key: SitePageBackgroundKey
): CSSProperties {
  return { background: sitePageBackground[key] };
}

/** 首页：CSS 内多处引用 --home-canvas-bg */
export function homePageBackgroundStyle(): CSSProperties {
  return {
    "--home-canvas-bg": sitePageBackground.home,
  } as CSSProperties;
}

/** 产品页：CSS 内引用 --lf-product-page-bg */
export function productPageBackgroundCssVars(): CSSProperties {
  return {
    "--lf-product-page-bg": sitePageBackground.product,
  } as CSSProperties;
}

/** 空间内产品区统一衬底容器（铺满视口宽、抵消 .space-content padding） */
export function spaceProductShellStyle(): CSSProperties {
  return {
    ...productPageBackgroundCssVars(),
    ...sitePageBackgroundStyle("product"),
  };
}

/** 顶栏用户头像：CSS 内引用 --lf-nav-user-avatar-size */
export function siteNavUserAvatarCssVars(): CSSProperties {
  return {
    "--lf-nav-user-avatar-size": `${siteNavUserAvatarSize}px`,
  } as CSSProperties;
}
